(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ol-interaction-system"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.body.classList.contains('ol-refined')) return;
    const updateHeader = () => {
      const header = document.getElementById('ol-header');
      if (header) header.classList.toggle('ol-refined-scrolled', window.scrollY > 24);
    };
    let scheduled = false;
    window.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { updateHeader(); scheduled = false; });
    }, { passive: true });
    document.addEventListener('shopify:section:load', updateHeader);
    updateHeader();
  })();
  } catch(e) { console.error(e); }
})();

})();
